import React from "react";
import { Link as RouterLink } from "react-router-dom";
import {
  Box,
  Flex,
  HStack,
  Link,
  IconButton,
  useDisclosure,
  useColorMode,
  Stack,
  Image,
  Alert,
  AlertIcon,
  AlertTitle,
} from "@chakra-ui/react";
import { HamburgerIcon, CloseIcon } from "@chakra-ui/icons";
import { MdOutlineDevices } from "react-icons/md";
const Links = ["Home", "About", "Services", "Portfolio", "Blog", "Contact"];

const NavLink = ({ children }) => (
  <Link
    as={RouterLink}
    px={2}
    py={1}
    rounded={"md"}
    _hover={{
      textDecoration: "none",
      bg: "brand.green",
      color: "brand.cream",
    }}
    to={children === "Home" ? "/" : `/${children.toLowerCase()}`}
  >
    {children}
  </Link>
);

export default function Navbar() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { colorMode } = useColorMode(); // Get the current color mode

  // Conditionally set the background color based on the color mode
  const alertBgColor = colorMode === "light" ? "brand.green" : "brand.orange";

  return (
    <>
      <Box bg={colorMode === "light" ? "brand.cream" : "brand.navy"} px={4}>
        {/* Navbar Section */}
        <Flex h={{ base: 16, md: 24 }} alignItems={"center"} justifyContent={"space-between"}>
          <IconButton
            size={"md"}
            icon={isOpen ? <CloseIcon /> : <HamburgerIcon />}
            aria-label={"Open Menu"}
            display={{ md: "none" }}
            onClick={isOpen ? onClose : onOpen}
          />
          <HStack spacing={8} alignItems={"center"}>
            <Box
              position={{ base: "absolute", md: "static" }}
              left="50%"
              transform={{ base: "translateX(-50%)", md: "none" }}
            >
              <Image
                src={colorMode === "light" ? require("../assets/images/satoal-logo-black.png") : require("../assets/images/satoal-logo-white.png")}
                alt="Satoal Logo"
                h={{ base: "60px", md: "60px", lg: "80px" }}
                maxW={{ base: "120px", md: "180px", lg: "240px" }}
                objectFit="contain"
              />
            </Box>
            <HStack as={"nav"} spacing={4} display={{ base: "none", md: "flex" }}>
              {Links.map((link) => (
                <NavLink key={link}>{link}</NavLink>
              ))}
            </HStack>
          </HStack>
        </Flex>

        {isOpen ? (
          <Box pb={4} display={{ md: "none" }}>
            <Stack as={"nav"} spacing={4}>
              {Links.map((link) => (
                <NavLink key={link}>{link}</NavLink>
              ))}
            </Stack>
          </Box>
        ) : null}
      </Box>

      {/* Alert Section - Always Visible */}
      <Box mt={4}>
        <Alert status="info" variant="solid" bg={alertBgColor}>
          <AlertIcon boxSize={6} />
          <HStack>
            <AlertTitle fontSize={16} alignSelf={'center'} mr={2}>Website is currently under developement</AlertTitle>
            <MdOutlineDevices size={20} />
          </HStack>
        </Alert>
      </Box>
    </>
  );
}
